export const getCanvasContextWithImage = async (imageUrl: string, scale = 1) => {
  const canvas = document.createElement('canvas');
  let blob: Blob;
  try {
    const response = await fetch(imageUrl);
    blob = await response.blob();
  } catch (error) {
    console.error('Failed loading image:', error);
    return null;
  }
  const imageBitmap = await createImageBitmap(blob);
  canvas.width = imageBitmap.width * scale;
  canvas.height = imageBitmap.height * scale;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Failed to get canvas 2D context');
  }
  ctx.scale(scale, scale);
  ctx.drawImage(imageBitmap, 0, 0);
  const cleanedUp = () => {
    imageBitmap.close();
    canvas.parentNode?.removeChild(canvas);
  };
  return {
    ctx,
    canvas,
    cleanedUp
  };
};